export default __webpack_public_path__ + "static/assets/c504da7f10a757bfe352273c4b649470.png";